<template>
    <section v-if="slides.length" class="relative overflow-hidden" aria-label="Aktualne promocje">
        <div class="carousel-inner relative overflow-hidden w-full">
            <div v-for="(img, i) in slides" :id="`slide-${i}`" :key="i"
                 :class="active === i ? 'active' : 'left-full'"
                 :aria-hidden="active !== i"
                 class="carousel-item inset-0 relative w-full transform transition-all duration-500 ease-in-out">
                <a :href="img.url || img.src" :tabindex="active === i ? 0 : -1">
                    <img class="block w-full" :src="img.src" :alt="img.name"/>
                </a>
            </div>
        </div>
        <div v-if="slides.length > 1" class="carousel-indicators flex flex-wrap bg-gray-100 py-3 px-4 w-full justify-center items-center gap-2">
            <button v-for="(img, i) in slides" :key="i" type="button"
                    class="flex h-6 w-6 items-center justify-center rounded-full focus:outline-none focus:ring-2 focus:ring-indigo-600"
                    :aria-label="`Pokaż reklamę: ${img.name}`"
                    :aria-pressed="active === i"
                    @click="selectSlide(i)">
                <span class="block w-3 h-3 rounded-full"
                      :class="active === i ? 'bg-indigo-600' : 'bg-gray-300'"></span>
            </button>
        </div>
    </section>
</template>

<script>
export default {
    name: "Carousel",

    data: () => ({
        slides: [],
        active: 0,
        intervalId: null,
        requestController: null,
    }),
    methods: {
        async getSlides() {
            this.requestController = new AbortController();

            try {
                const response = await axios.get('/api/uchowanca/slides', {
                    signal: this.requestController.signal,
                });
                this.slides = Array.isArray(response.data.slides)
                    ? response.data.slides.filter(slide => slide && typeof slide.src === 'string' && slide.src)
                    : [];
                this.startRotation();
            } catch (error) {
                if (!axios.isCancel(error)) {
                    console.warn('Nie udało się wczytać reklam.', error);
                }
            }
        },
        startRotation() {
            clearInterval(this.intervalId);
            if (this.slides.length > 1) {
                this.intervalId = setInterval(() => {
                    this.active = (this.active + 1) % this.slides.length;
                }, 3000);
            }
        },
        selectSlide(index) {
            this.active = index;
            this.startRotation();
        },
    },
    created() {
        this.getSlides();
    },
    beforeUnmount() {
        this.requestController.abort();
        clearInterval(this.intervalId);
    },
}
</script>

<style scoped>
.left-full {
    left: -100%;
}

.carousel-item {
    float: left;
    position: relative;
    display: block;
    width: 100%;
    margin-right: -100%;
    backface-visibility: hidden;
}

.carousel-item.active {
    left: 0;
}
</style>
